/**
 * @generated SignedSource<<7b973d7e66102d8223a1d4c3cae6a53e>>
 * @relayHash fcd1377a74b6e682479cd92c8be303b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e47474fbf95b94b1c4596f5f3a4968cce3a4d363b0daf94694a46d1df6d49d79

import type { ConcreteRequest, Query } from 'relay-runtime';
export type collectionChangePlanPopupQuery$variables = {
  cloudId: string;
  collectionEntitlementId: string;
  hamsProductKey: string;
  shouldShowPspLink: boolean;
};
export type collectionChangePlanPopupQuery$data = {
  readonly ccp?: {
    readonly entitlementV2: {
      readonly experienceCapabilities: {
        readonly manageEntitlement: {
          readonly experienceUrl: string | null | undefined;
          readonly isAvailableToUser: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly tenantContexts?: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type collectionChangePlanPopupQuery = {
  response: collectionChangePlanPopupQuery$data;
  variables: collectionChangePlanPopupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collectionEntitlementId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hamsProductKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldShowPspLink"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v4 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "collectionEntitlementId"
  }
],
v6 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpManageEntitlementExperienceCapability",
      "kind": "LinkedField",
      "name": "manageEntitlement",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v3/*: any*/)
      ]
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "collectionChangePlanPopupQuery",
    "selections": [
      {
        "condition": "shouldShowPspLink",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "experienceCapabilities",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "changeOfferingV2",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldShowPspLink",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "CcpQueryApi",
            "kind": "LinkedField",
            "name": "ccp",
            "plural": false,
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "CcpEntitlement",
                "kind": "LinkedField",
                "name": "entitlementV2",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "collectionChangePlanPopupQuery",
    "selections": [
      {
        "condition": "shouldShowPspLink",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "experienceCapabilities",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "changeOfferingV2",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldShowPspLink",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "CcpQueryApi",
            "kind": "LinkedField",
            "name": "ccp",
            "plural": false,
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "CcpEntitlement",
                "kind": "LinkedField",
                "name": "entitlementV2",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v8/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e47474fbf95b94b1c4596f5f3a4968cce3a4d363b0daf94694a46d1df6d49d79",
    "metadata": {},
    "name": "collectionChangePlanPopupQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "211b64b0f169b5ec96f63f9e5238ed73";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
